import React, { Component } from 'react';
import styles from './ObjetVue.module.scss';
import Bouton from '../../../UI/Bouton/Bouton';
import { stringOrEmptyString } from '../../../../ressources/functionJS/stringOrEmptyString';
import * as glossaire_type_objets_vue from '../../../../ressources/glossaires/glossaire_type_objets_vue';
import * as glossaire_type_export from '../../../../ressources/glossaires/glossaire_type_export';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import { ratioStyleCSS2PuissanceNiveauZoom } from '../../../../ressources/functionJS/ratioStyleCSS2PuissanceNiveauZoom';
import { setUrlPathFromDomain } from '../../../../services/utils/utils';

class ObjetVue extends Component {
  state = {
    viewobj_json_content: null,
    attenteRecupFichierJson: false,
  };

  // Lifecycle method to fetch JSON content when component mounts
  componentDidMount() {
    this.fetchViewObjectContent();
  }

  // Extract JSON fetching logic to its own method
  fetchViewObjectContent = () => {
    const { objetAAfficher, viewobj_json_content } = this.props;

    // Check if we should fetch the JSON content
    if (
      !this.state.viewobj_json_content && // Don't have content yet
      !this.state.attenteRecupFichierJson && // Not currently fetching
      objetAAfficher?.viewobj_path && // Have a path to fetch
      stringOrEmptyString(objetAAfficher.viewobj_path) !== '' && // Path is not empty
      viewobj_json_content === undefined // Not provided by props
    ) {
      this.setState({ attenteRecupFichierJson: true });

      try {
        // Construct the URL
        const cheminURL = setUrlPathFromDomain(
          objetAAfficher.viewobj_path,
          `https://${document.domain}${objetAAfficher.viewobj_path.slice(1)}`
        );

        // Add cache-busting parameter
        const fetchURL = `${cheminURL}?varget${Math.random()}`;

        // Fetch the JSON content
        fetch(fetchURL)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            this.setState({
              attenteRecupFichierJson: false,
              viewobj_json_content: data,
            });
          })
          .catch((error) => {
            console.error('Error fetching view object content:', error);
            this.setState({
              attenteRecupFichierJson: false,
            });
          });
      } catch (error) {
        console.error('Error in URL construction:', error);
        this.setState({
          attenteRecupFichierJson: false,
        });
      }
    }
  };

  // Helper method to apply zoom styling
  applyZoomStyling = (style, isFixedSize) => {
    if (isFixedSize) {
      return style;
    }
    return ratioStyleCSS2PuissanceNiveauZoom(style, this.props.mapZoom);
  };

  // Helper method to get the button or object name
  getDisplayName = () => {
    const { viewobj_json_content } = this.state;
    const { objetAAfficher } = this.props;

    return viewobj_json_content?.nom_du_bouton !== undefined
      ? viewobj_json_content.nom_du_bouton
      : objetAAfficher.name;
  };

  // Main render method now cleaner with helper methods
  render() {
    const { objetAAfficher } = this.props;
    const { viewobj_json_content } = this.state;

    // Early return if no object to display
    if (!objetAAfficher) {
      return null;
    }

    // If JSON content is loading or not yet defined, use default representation
    if (
      !viewobj_json_content ||
      viewobj_json_content.type_de_representation === undefined
    ) {
      return (
        <Bouton cliquer={() => this.openViewInNewWindow()}>
          {objetAAfficher.name}
        </Bouton>
      );
    }

    // Switch based on representation type
    switch (viewobj_json_content.type_de_representation) {
      case glossaire_type_objets_vue.affichgedirectvue:
        return (
          <div>
            /!\ Attention chantier en cours problème d'appel en boucle (vue1 -
            {'>'} vue1 -{'>'} vue1 ...)
          </div>
        );

      case glossaire_type_objets_vue.bouton_de_redirection:
        return (
          <button
            style={this.applyZoomStyling(
              viewobj_json_content.styleMainDiv,
              viewobj_json_content.tailleFixe === true
            )}
            onClick={() => this.openViewInNewWindow()}
            className={[s.btn, s.btn_sm].join(' ')}
            disabled={viewobj_json_content.disabled === true}
          >
            {this.getDisplayName()}
          </button>
        );

      case glossaire_type_objets_vue.bouton_de_redirection_label:
        if (this.props.objetAAfficher.view_in_view_id === this.props.view_id) {
          return (
            <button
              className={[
                s.btn,
                s.btn_sm,
                styles.bouton_full,
                styles.active,
              ].join(' ')}
              style={{
                ...(this.state.viewobj_json_content.tailleFixe === true
                  ? this.state.viewobj_json_content.styleMainBouton
                  : ratioStyleCSS2PuissanceNiveauZoom(
                      this.state.viewobj_json_content.styleMainBouton,
                      this.props.mapZoom
                    )),
              }} //tailleFixe dans le json pour fixe la taille de l'objet peu importe le niveau de zoom
              disabled={true}
            >
              <span
                className={styles.rond}
                style={{
                  ...this.state.viewobj_json_content.styleRondSpan,
                }}
              />
              <span
                className={[styles.text_bouton, styles.text_active].join(' ')}
                style={{
                  ...this.state.viewobj_json_content.styleLabelSpan,
                }}
              >
                {this.state.viewobj_json_content.nom_du_bouton !== undefined
                  ? this.state.viewobj_json_content.nom_du_bouton
                  : this.props.objetAAfficher.name}
              </span>
            </button>
          );
        } else {
          return (
            <Bouton
              cliquer={() => {
                window.open(
                  `/export_impression_ecran-${glossaire_type_export.visualisation}-${this.props.objetAAfficher.view_in_view_id}`,
                  '_blank',
                  `toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,innerWidth=${window.screen.availWidth},innerHeight=${window.screen.availHeight}`
                );
              }}
              ajoutClass={[styles.bouton_full].join(' ')}
              style={{
                ...this.state.viewobj_json_content.styleMainBouton,
              }}
            >
              <span
                className={styles.rond}
                style={{
                  ...this.state.viewobj_json_content.styleRondSpan,
                }}
              />
              <span
                className={styles.text_bouton}
                style={{
                  ...this.state.viewobj_json_content.styleLabelSpan,
                }}
              >
                {this.state.viewobj_json_content.nom_du_bouton !== undefined
                  ? this.state.viewobj_json_content.nom_du_bouton
                  : this.props.objetAAfficher.name}
              </span>
            </Bouton>
          );
        }

      case glossaire_type_objets_vue.bouton_de_redirection_image:
        return (
          <img
            alt={this.state.viewobj_json_content.img_alt}
            src={this.state.viewobj_json_content.src_img}
            style={{
              ...(this.state.viewobj_json_content.tailleFixe === true
                ? this.state.viewobj_json_content.styleMainDiv
                : ratioStyleCSS2PuissanceNiveauZoom(
                    this.state.viewobj_json_content.styleMainDiv,
                    this.props.mapZoom
                  )),
            }} //tailleFixe dans le json pour fixe la taille de l'objet peu importe le niveau de zoom
            onClick={() => {
              window.open(
                `/export_impression_ecran-${glossaire_type_export.visualisation}-${this.props.objetAAfficher.view_in_view_id}`,
                '_blank',
                `toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,innerWidth=${window.screen.availWidth},innerHeight=${window.screen.availHeight}`
              );
            }}
            className={[s.btn, s.btn_sm].join(' ')}
          />
        );

      default:
        return <div>Défaut</div>;
    }
  }

  // Helper method to open views in a new window
  openViewInNewWindow = () => {
    const { objetAAfficher } = this.props;

    window.open(
      `/export_impression_ecran-${glossaire_type_export.visualisation}-${objetAAfficher.view_in_view_id}`,
      '_blank',
      `toolbar=no,scrollbars=yes,dependent=yes,top=0,left=0,innerWidth=${window.screen.availWidth},innerHeight=${window.screen.availHeight}`
    );
  };
}

export default ObjetVue;
